<template>
  <CContainer fluid class="mt-3">
    <CCard>
      <CCardBody>
        <CRow>
          <CCol md="6">
            <CSelect
              :options="licenseOptions"
              :value.sync="licenseInput"
              label="License :"
              placeholder="Silahkan Pilih License"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CSelect
              :options="monthOptions"
              :value.sync="monthInput"
              label="Bulan :"
            ></CSelect>
          </CCol>
          <CCol>
            <CSelect
              :options="yearOptions"
              :value.sync="yearInput"
              label="Tahun :"
            ></CSelect>
          </CCol>
        </CRow>
        <div class="my-2 d-flex">
          <div class="d-flex">
            <CButton size="sm" color="success" :disabled="licenseInput == ''" @click="fetchCSV()">Download</CButton>
          </div>
        </div>
      </CCardBody>
    </CCard>
    <CModal
      color="primary"
      :show.sync="showErrorModal" :centered="true">
      <div slot="header"><h5>{{modalTitle}}</h5></div>
      <div class="">
        {{errorLabel}}
      </div>
      <div slot="footer">
        <CButton color="primary" @click="showErrorModal = false">OK</CButton>
      </div>
    </CModal>
    <CModal
     color="primary"
     :show.sync="showModalCsv" :centered="true"
     :closeOnBackdrop="false"
    >
      <div slot="header">
        <h5>Reporting</h5>
      </div>
      <div class="">
        CSV File anda berhasil di buat.
      </div>
      <div slot="footer">
        <vue-json-to-csv v-if="jsonToCsvData.length != 0" class="json-to-csv-button btn-primary" :json-data="jsonToCsvData" :csv-title="csvTitle">Unduh</vue-json-to-csv>
        <CButton class="ml-2" color="danger" :disabled="disableDownload" @click="showModalCsv = false">Cancel</CButton>
      </div>
    </CModal>
  </CContainer>
</template>

<script>
import VueJsonToCsv from 'vue-json-to-csv';
export default {
  components: {
    VueJsonToCsv
  },
  data(){
    return {      
      errorLabel: 'System Error!',
      modalTitle: 'Error',
      showErrorModal: false,
      jsonToCsvData: [],
      csvTitle: 'my-csv',
      showModalCsv: false,
      now: new Date(),
      licenseOptions: [],
      licenseInput: '',
      //monthOptions: [],
      monthInput: '',
      yearOptions: [],
      yearInput: ''
    }
  },
  methods: {
    fetchCSV(){
      this.$store.commit('set', ['isLoading', true]);
      let processUrl = 'api/backend/v2/dashboard/csv';
      var startDate = new Date(this.yearInput, this.monthInput, 1);
      var endDate = new Date(this.yearInput, this.monthInput + 1, 0);
      let startDateFormatted = startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + '-' + startDate.getDate();
      let endDateFormatted = endDate.getFullYear() + '-' + (endDate.getMonth() + 1) + '-' + endDate.getDate();
      this.$axios.post(processUrl, {license_id: this.licenseInput, start_date: startDateFormatted, end_date: endDateFormatted, status: 'all'})
      .then(async (response) => {
        if(response.status == 200){
          if(response.data.success){
            if(response.data.data.length > 0){
              this.jsonToCsvData = response.data.data;
              this.csvTitle = startDateFormatted+ '_'+endDateFormatted+' data';
              this.showModalCsv = true;
            } else {
              this.modalTitle = 'Data kosong';
              this.errorLabel = 'Data API Hit untuk rentang tanggal yang dipilih kosong';
              this.showErrorModal = true;
            }            
            this.$store.commit('set', ['isLoading', false]);
          } else {
            this.errorLabel = response.data.message;
            this.$store.commit('set', ['isLoading', false]);
            this.showErrorModal = true;
          }
        } else {
          this.errorAction(response);
        }
      })
      .catch((err) => {
        this.errorAction(err);
      })
    },
    getLicenseOptions(){
      this.$store.commit('set', ['isLoading', true]);
      let processUrl = 'api/backend/v2/licenses';
      return this.$axios.get(processUrl)
      .then(async (response) => {
        if(response.status == 200){
          if(response.data.success){
            let options = response.data.data;
            for (const iterator of options) {
              let option = { value: iterator.id, label: iterator.name};
              this.licenseOptions.push(option);
            }
            this.$store.commit('set', ['isLoading', false]);
          } else {
            this.errorLabel = response.data.message;
            this.$store.commit('set', ['isLoading', false]);
            this.showErrorModal = true;
          }
        } else {
          this.errorAction(response);
        }
      })
      .catch((err) => {
        this.errorAction(err);
      })
    },
    errorAction(error){
      let listError = this.$helper.errorHandling(error);
      this.modalTitle = this.$errorLabel.generic;
      this.errorLabel = 'Terjadi kesalahan: '+listError[0] || 'Unknown Error';
      this.$store.commit('set', ['isLoading', false]);
      this.showErrorModal = true;
    },
    generateYear(){
      let nowYear = this.now.getFullYear();
      let startYear = 2019;
      for (let index = startYear; index <= nowYear; index++) {
        this.yearOptions.push({ value: index, label: index});        
      }
    }
  },
  computed: {
    monthOptions(){      
      let months = [];
      let nowYear = this.now.getFullYear();
      let monthsName = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 
      'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
      if(this.yearInput == nowYear){
        let nowMonth = this.now.getMonth();
        for (let index = 0; index <= nowMonth; index++) {
          months.push({ value: index, label: monthsName[index] })          
        }
      } else {
        for (let index = 0; index <= 11; index++) {
          months.push({ value: index, label: monthsName[index] })          
        }
      }
      return months;
    },
    disableDownload(){
      if(this.licenseInput == '' || this.monthInput == '' || this.yearInput == ''){
        return true;
      } else { return false }
    }
  },
  async created(){
    await this.getLicenseOptions();
    this.licenseInput = this.licenseOptions[0].value;
    this.generateYear();
    this.yearInput = this.now.getFullYear();
    this.monthInput = this.now.getMonth();
  }
}
</script>

<style>

</style>